import React from 'react';
import { NavLink } from 'react-router-dom';
import { brandAssets } from '../assets';

/**
 * Navigation component with responsive mobile menu support.
 * Includes hamburger menu, backdrop overlay, and desktop navigation.
 *
 * @param {Object} props
 * @param {boolean} props.scrolled - Whether the page has been scrolled
 * @param {boolean} props.mobileMenuOpen - Whether mobile menu is open
 * @param {Function} props.toggleMobileMenu - Handler to toggle mobile menu
 * @param {Function} props.closeMobileMenu - Handler to close mobile menu
 */
const Navigation = ({ scrolled, mobileMenuOpen, toggleMobileMenu, closeMobileMenu }) => {
  return (
    <>
      {/* Hamburger Menu Button - Fixed position on mobile */}
      <button
        className={`hamburger ${mobileMenuOpen ? 'hamburger-active' : ''}`}
        onClick={toggleMobileMenu}
        aria-label="Toggle menu"
        aria-expanded={mobileMenuOpen}
      >
        <span className="hamburger-line"></span>
        <span className="hamburger-line"></span>
        <span className="hamburger-line"></span>
      </button>

      {/* Mobile Menu Backdrop */}
      {mobileMenuOpen && (
        <div className="nav-backdrop" onClick={closeMobileMenu}></div>
      )}

      <nav className={`navbar ${scrolled ? 'navbar-scrolled' : ''} ${mobileMenuOpen ? 'nav-menu-active' : ''}`}>
        <div className="nav-container">
          <NavLink to="/" className="nav-logo-link" onClick={closeMobileMenu}>
            <img src={brandAssets.logo} alt="One Stop Capital" className="nav-logo-image" />
          </NavLink>

          {/* Desktop & Mobile Menu */}
          <ul className={`nav-menu ${mobileMenuOpen ? 'nav-menu-open' : ''}`}>
            <li className="nav-item">
              <NavLink to="/" className="nav-link" onClick={closeMobileMenu}>Home</NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/about" className="nav-link" onClick={closeMobileMenu}>About</NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/team" className="nav-link" onClick={closeMobileMenu}>Team</NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/contact" className="nav-link" onClick={closeMobileMenu}>Contact</NavLink>
            </li>
          </ul>
        </div>
      </nav>
    </>
  );
};

export default Navigation;
